import { CommonModule } from '@angular/common';
import { Component, EventEmitter, HostListener, Input, Output } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'app-update-dialog',
  standalone: true,
  imports: [MatIconModule, CommonModule, MatButtonModule],
  templateUrl: './update-dialog.component.html',
  styleUrls: ['./update-dialog.component.css']
})
export class UpdateDialogComponent {
  @Input() data: any;
  @Input() show = false;
  @Output() closed = new EventEmitter<void>();
  @Output() confirmed = new EventEmitter<void>();

  get canClose(): boolean {
    return !this.data?.mandatory;
  }

  get updateMessage(): string {
    if (!this.data) return '';
    
    if (this.data.mandatory) {
      return 'This is a mandatory update. Please update to continue using the app.';
    }
    return 'We recommend updating to get the latest features and improvements.';
  }

  onCancel() {
    if (this.canClose) {
      this.show = false;
      this.closed.emit();
    } else {
      this.showMandatoryAlert();
    }
  }

  onUpdate() {
    this.confirmed.emit();
  }

  private showMandatoryAlert() {
    // Create a simple alert for mandatory updates
    const alertDiv = document.createElement('div');
    alertDiv.className = 'fixed top-4 left-1/2 transform -translate-x-1/2 bg-red-500 text-white px-6 py-3 rounded-lg shadow-lg z-[100] transition-opacity';
    alertDiv.textContent = 'This update is mandatory to continue using the app.';
    
    document.body.appendChild(alertDiv);
    
    setTimeout(() => {
      alertDiv.style.opacity = '0';
      setTimeout(() => alertDiv.remove(), 300);
    }, 3000);
  }

  // Prevent closing with Escape key for mandatory updates
  @HostListener('document:keydown.escape', ['$event'])
  handleEscape(event: KeyboardEvent) {
    if (!this.canClose) {
      event.preventDefault();
      this.showMandatoryAlert();
    } else {
      this.onCancel();
    }
  }

  // Prevent closing by clicking the overlay for mandatory updates
  onOverlayClick() {
    if (this.canClose) {
      this.onCancel();
    } else {
      this.showMandatoryAlert();
    }
  }
}